import WebModule from '../web_module'

export default class System extends WebModule

  @selector: '.modulor_web_module_system'

# do not register since this is just superclass
